import React, { useEffect, useState} from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { removeUnreadChatCount } from 'sr/redux/reducers/companychat'
import { MainWrapper } from './component/MainWrapper'
import { TopBar } from './component/TopBar'
import { Noselected } from './component/Messages/Noselected'
import { ModelWrapper } from './component/ModelWrapper'
import { Checkbox } from 'sr/helpers'
import { ChatBox } from './component/Messages/ChatBox'
import { FormattedMessage } from 'react-intl'
import { getUserDetails } from 'sr/helpers/functions/getUserDetails'
import { getApplication } from 'sr/utils/api/cleaner/getApplication'
import Application from '../component/types/cleaner/application'
import { DateFormat } from 'sr/helpers/functions/DateFormat'
import ContentWithSpinner from 'sr/layout/common/ContentWithSpiner'
import { getJobs } from 'sr/utils/api/cleaner/jobs/getJobs'
import Job from '../component/types/Job'
import CheckBoxHandle from 'sr/helpers/functions/CheckBoxHandle'
import { getUnreadMessageCount } from 'sr/utils/api/chat/getUnreadMessageCount'
import { getUnreadApplication } from 'sr/utils/api/cleaner/getUnreadApplication'
import { getMessage } from 'sr/utils/api/cleaner/getMessage'
import { updateMessage } from 'sr/utils/api/cleaner/updateMessage'
import { useSocket } from 'app/pages/component/SocketContext'

export const Messages = () => {
    const dispatch = useDispatch()
    const [modelShow, setModelshow] = useState(false)
    const [companyId, setCompanyId] = useState<string>('')
    const [loader, setLoader] = useState(true)
    const [candidates, setCandidates] = useState<Application[]>([])
    const [current, setCurrent] = useState<Application>()
    const [jobs, setJobs] = useState<Job[]>([])
    const [selectedJobs, setSelectedJobs] = useState([])
      const [allUnreadApplication, setAllUnreadApplication] = useState([])
    const [unreadApplication, setUnreadApplication] = useState<Application[]>([])
      const [tab, setTab] = useState('Inbox')
    const [localMessageTimes, setLocalMessageTimes] = useState<Record<string, string>>({})
    
    const getJobId = (item) => item?.job_id?._id || item?.job_id?.id || item?.job_id
    
    useEffect(()=> {
                const {user_id} = getUserDetails()
                setCompanyId(user_id)
    },[companyId])
    const HandleModelByProps = (data) => {
        setModelshow(data)
       }
       const fetchJobs = async ()=> {
        const queryParams = new URLSearchParams();  
        if (companyId) queryParams.append('company_id', companyId.toString());
const result = await getJobs(queryParams)
      if(result?.success===true) {
      setJobs(result?.data)
       }
    }
       const fetchCandidates = async ()=> {
        try {
          setLoader(true)
            const queryParams = new URLSearchParams();  
            queryParams?.append('company_id', companyId)
            if (selectedJobs?.length>0) queryParams.append('job_id', selectedJobs?.toString())
            const result = await getApplication(queryParams)
            if(result.success===true) {
                 setCandidates(result?.data)
                 
                 setLoader(false)
              }
        }
        catch(e) {
            setLoader(false)
        }
    }
    useEffect(()=> {
        if(companyId) {
            fetchCandidates()
            fetchJobs()
        }
    },[companyId])
    useEffect(()=> {
        if(selectedJobs?.length>0){
            fetchCandidates()
        }
    },[selectedJobs])
    const location = useLocation()
    const navigate = useNavigate()
    const selectedJobId = new URLSearchParams(location.search).get("jobId")
    const selectedCleanerId = new URLSearchParams(location.search).get("cleanerId")

    const listToRender = tab === 'Inbox' ? candidates : unreadApplication;
    const getCandJobId = (c: any) => typeof c?.job_id === 'string' ? c?.job_id : (c?.job_id?._id || c?.job_id?.id);
    const getCandCleanerId = (c: any) => typeof c?.cleaner_id === 'string' ? c?.cleaner_id : (c?.cleaner_id?._id || c?.cleaner_id?.id);

    const getLastMessageTime = (data: any) => {
        const key = `${getCandCleanerId(data)}_${getCandJobId(data)}`;
        if (localMessageTimes[key]) return localMessageTimes[key];
        
        const chatInfo = allUnreadApplication?.find((item)=> getCandCleanerId(item) === getCandCleanerId(data) && getJobId(item) === getJobId(data));
        return chatInfo?.lastMessageTime || data?.lastMessageTime || data?.updatedAt || data?.createdAt;
    };

    const sortedList = [...(listToRender || [])].sort((a, b) => {
        const timeA = new Date(getLastMessageTime(a)).getTime();
        const timeB = new Date(getLastMessageTime(b)).getTime();
        return timeB - timeA;
    });

    useEffect(()=> {
    if(sortedList?.length) {
        let found;
        if (selectedJobId && selectedCleanerId) {
            found = sortedList.find(c => getCandJobId(c) === selectedJobId && getCandCleanerId(c) === selectedCleanerId);
            
            if (!found) {
                found = sortedList.find(c => getCandCleanerId(c) === selectedCleanerId);
            }
        } else if (selectedJobId) {
            found = sortedList.find(c => getCandJobId(c) === selectedJobId);
        }
        
        setCurrent(found || sortedList[0])
    }
    },[candidates, selectedJobId, selectedCleanerId, tab])

    const handleRefresh = ()=>{
        fetchCandidates()
    }
    const fetchUnreadCount = async (company_id)=> {
    try {
        const queryParams = await new URLSearchParams()
        queryParams.append('company_id', company_id)
    const res = await getUnreadMessageCount(queryParams)
    if(res?.success===true){
    setAllUnreadApplication(res?.data)
    }
    }
    catch(e){
    
    }
    }
    useEffect(()=>{
    if(companyId){
        fetchUnreadCount(companyId)
    }
    },[companyId])

    const fetchUnreadApplication = async ()=>{
        try{
            const queryParams = new URLSearchParams()
            queryParams.append('company_id', companyId)
            const res = await getUnreadApplication(queryParams)
            if(res?.success===true){
                const currentJobId = current ? getCandJobId(current) : null;
                const currentCleanerId = current ? getCandCleanerId(current) : null;
                setUnreadApplication(
                    (currentJobId && currentCleanerId)
                        ? (res?.data || []).filter((item: any) => !(getJobId(item) === currentJobId && getCandCleanerId(item) === currentCleanerId))
                        : (res?.data || [])
                )
            }
        }
        catch(e){
        }
    }

    useEffect(()=>{
            if(companyId){
                fetchUnreadApplication()
            }
    },[companyId])

    const clearUnreadForJob = (jobId: string, cleanerId: string) => {
        if (!jobId || !cleanerId) return;
        setUnreadApplication((prev: any) => prev?.filter((item: any) => !(getJobId(item) === jobId && getCandCleanerId(item) === cleanerId)));
        setAllUnreadApplication((prev: any) => prev?.filter((item: any) => !(getJobId(item) === jobId && getCandCleanerId(item) === cleanerId)));
    };

    useEffect(() => {
        if (current) {
            const jId = getCandJobId(current);
            const cId = getCandCleanerId(current);
            if (jId && cId) {
                clearUnreadForJob(jId, cId);
                dispatch(removeUnreadChatCount({ job_id: jId }));
            }
        }
    }, [current, dispatch]);

    const socket = useSocket()
    useEffect(() => {
      if (!socket || !companyId) return
    
      const handleSendMessage = ({ messagewithFullData: message }) => {
        if (message?.sender_id_type === "cleaner") {
          const jobId = typeof message?.job_id === 'string' ? message?.job_id : (message?.job_id?._id || message?.job_id?.id);
          const senderId = typeof message?.sender_id === 'string' ? message?.sender_id : (message?.sender_id?._id || message?.sender_id?.id);
          
          const currentJobId = typeof current?.job_id === 'string' ? current?.job_id : (current?.job_id?._id || current?.job_id?.id);
          const currentCleanerId = typeof current?.cleaner_id === 'string' ? current?.cleaner_id : (current?.cleaner_id?._id || current?.cleaner_id?.id);
          
          const isCurrentlyViewing = current && currentJobId === jobId && currentCleanerId === senderId;
          
          if (!isCurrentlyViewing) {
            fetchUnreadApplication();
            fetchUnreadCount(companyId);
          }
          
          if (jobId && senderId) {
             setLocalMessageTimes(prev => ({...prev, [`${senderId}_${jobId}`]: new Date().toISOString()}));
          }
        }
      }
    
      socket.on("sendmessage", handleSendMessage)
    
      return () => {
        socket.off("sendmessage", handleSendMessage)
      }
    }, [socket, companyId, current])

    const handleUnread = ()=> {

    }
  return (
   <MainWrapper>
    <ContentWithSpinner loader={loader} height='h-screen'>
    <div className='py-3'>
    <TopBar title = {<FormattedMessage id='RECRUITER.MESSAGES.TITLE' defaultMessage='Messages' />}></TopBar>
    <div className={`flex border-y border-neutral-200 bg-white h-full`}>
        <div className='py-3 border-r-2 border-neutral-300 h-[calc(100vh-170px)] overflow-x-auto'>
        <div className='flex items-center mb-3 px-4'>
<div onClick={()=> setTab('Inbox')} className={`rounded-l-lg ${tab==='Inbox' ? 'bg-[#ff39b3] text-white' : 'bg-white text-[#0078ae] border border-neutral-200'} font-bold px-3 py-1  cursor-pointer`}>
<FormattedMessage id="RECRUITER.MESSAGES.TOGGLE.BUTTON.INBOX" defaultMessage="Inbox" />
</div>
<div onClick={()=> setTab('Unread')} className={`rounded-r-lg flex-1 text-center ${tab==='Unread' ? 'bg-[#ff39b3] text-white' : 'bg-white text-[#0078ae] border border-neutral-200'} font-bold px-3 py-1  cursor-pointer`}>
<FormattedMessage id="RECRUITER.MESSAGES.TOGGLE.BUTTON.UNREAD" defaultMessage="Unread" />({unreadApplication?.length})
</div>
    </div>
    <div className='flex items-center space-x-3 relative px-4'>
        <div onClick={()=> setModelshow(!modelShow)}  className='cursor-pointer flex-1 flex items-center py-2 px-2 justify-between border rounded-lg border-black hover:shadow-inputshadow hover:border-[#0078ae]'>
        <span><b><FormattedMessage id="RECRUITER.MESSAGES.FILTER.TITLE" defaultMessage="Filter by job" />:</b> <FormattedMessage id="RECRUITER.MESSAGES.FILTER.COMMON.TYPE" defaultMessage="All Jobs" /></span>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
</svg></div>
<svg onClick={handleRefresh} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-[#0078ae]">
  <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
</svg>

    
    {modelShow && 
    <ModelWrapper showModal={modelShow} HandleModelByProps={HandleModelByProps} topPosition='top-5' border='border border-black'>
    <div className=' w-full px-4 py-4'>
    {jobs?.map((item)=> (
<Checkbox key={item?.id} id={`${item?.job_title}`} label={`${item?.job_title}`} checked={selectedJobs?.includes(item?.id)}  name='Web' onChange={(e)=> CheckBoxHandle(e, selectedJobs, setSelectedJobs)} value={item?.id}/>
   ))}    </div>
    </ModelWrapper>
}
        </div>
        <hr className='border-2 border-neutral-200 mt-4'></hr>
          {(() => {
              return sortedList?.map((data, index)=> (
                <div key={data?.id} onClick={()=> {
                    setCurrent(data);
                    const jId = getCandJobId(data);
                    const cId = getCandCleanerId(data);
                    if (jId && cId) {
                        navigate(`?jobId=${jId}&cleanerId=${cId}`, { replace: true });
                    }
                }} className={` ${current?.id === data?.id ? 'bg-[#ecf5ff]':'bg-white hover:bg-[#faf9f8]' } cursor-pointer relative p-4 border-b border-neutral-200`}>
        <div className='flex items-center justify-between space-x-2'>
        <span className='text-gray-600 font-sm'>
        Applied to {data?.job_id?.job_title}
        </span>
        <div className="">
        
        <span className='text-gray-600 font-sm'>
        {DateFormat(getLastMessageTime(data))}
        </span>
        {allUnreadApplication?.find((item)=> getCandCleanerId(item) === getCandCleanerId(data) && getJobId(item) === getJobId(data))?.unreadCount >0 &&
        <div className="rounded-full bg-[#ff39b3]  font-bold absolute top-12 right-6 text-white w-5 h-5 flex justify-center items-center">
            <span className="text-[0.8rem] ">{allUnreadApplication?.find((item)=> getCandCleanerId(item) === getCandCleanerId(data) && getJobId(item) === getJobId(data))?.unreadCount}</span></div>
        }
        </div>
        </div>
        <p className=''>{data?.cleaner_id?.first_name} {data?.cleaner_id?.last_name}</p>
        
                </div>
              ));
          })()}
        </div>
<div className='flex-1'>
    {current ? < ChatBox clearUnreadForJob={clearUnreadForJob} fetchUnreadApplication={fetchUnreadApplication} fetchUnreadCount={fetchUnreadCount} key={current?._id} data={current} updateLastMessageTime={(cleanerId, jobId, time) => setLocalMessageTimes(prev => ({...prev, [`${cleanerId}_${jobId}`]: time}))}/>:
    (
        (<Noselected />)
    )
    }
</div>
    </div></div>
    </ContentWithSpinner>
   </MainWrapper>
  )
}
